<template>
  <div class="about">
    <!-- 导航栏 -->
    <Navbar :entName="entName" :logo="logo" />


    <!-- 页面内容 -->
    <section class="about-content">
      <div class="container">
        <h2>{{ aboutInfo.title || '关于天津吾行大数据有限公司' }}</h2>
        <div v-if="aboutInfo.contentAll" v-html="aboutInfo.contentAll"></div>
        <div v-else>
          <div class="about-section">
            <p>
              在数字化转型加速的当下，天津吾行大数据有限公司以硬核技术为根基，以全场景服务为支撑，成为政企数字化升级的可靠伙伴。
            </p>
          </div>
          <div class="about-section">
            <h3>关于我们</h3>
            <p>
              天津吾行大数据有限公司，先后通过ISO9001质量体系认证和高新技术企业认证，以扎实的技术实力和规范的服务流程，赢得了众多客户的信赖。
              公司始终坚持以客户需求为导向，致力于为企事业单位提供高质量的软件产品与数字化解决方案。
            </p>
          </div>
          <div class="about-section">
            <h3>业务领域</h3>
            <p>公司业务聚焦三大核心板块，覆盖多个行业场景：</p>
            <h3>一、服务企业出海</h3>
            <p>助力中国企业拓展海外市场，提供一站式出海数字化服务：</p>
              <p>
            <ul>
              <li>
                跨境营销与获客：智能 SEO、谷歌广告、TikTok 广告、智能
                SEM、邮件营销、AI 群发、AI 访客、AI 获客
              </li>
              <li>海外社媒管理：社媒管家、贴文发布、多平台同步</li>
              <li>市场与数据洞察：市场分析、数据洞察、全球贸易、企搜全球</li>
              <li>基础服务：注册指导、授权绑定</li>
            </ul>
            </p>

             <h3>二、企业管理与业务软件</h3>
            <p>面向各类企业，提供全面的管理与业务软件定制开发服务，覆盖企业内部管理与生产制造全流程</p>
              <p>
            <ul>
              <li>
                企业核心管理系统：企业资源计划（ERP）、客户关系管理（CRM）、企业信息门户系统（WDEP）
              </li>
              <li>专项业务系统：仓库管理系统（WMS）、知识库系统、项目管理（PMS）、人力资源（HR）、办公自动化（OA）、数字化档案（eDRMS）</li>
              <li>生产型工业自动化：产品生命周期管理（PLM）、生产型企业工业自动化、生产型管理自动化系统</li>
              <li>办公与生产力工具：多参数产品报价系统</li>
            </ul>
            </p>
              <h3>三、定制化开发</h3>
            <p>根据客户个性化需求，提供技术开发与营销推广的整合服务：</p>
              <p>
            <ul>
              <li>
                平台搭建：堆场、运输、港口等专业系统定制化开发
              </li>
              <li>AI 技术应用：AI 技术在各领域的应用及定制化开发</li>
              <li>政务与社区服务：政务服务定制化开发、社区/商会/街道定制化服务</li>
              <li>通关与仓储服务：通关平台、仓储管理系统、集成其他系统</li>
            </ul>
            </p>
          </div>
          <div class="about-section">
            <h3>开发团队</h3>
            <p>
              &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;公司拥有一支高素质的技术开发团队，技术开发人员占比超过 80%，整体平均学历为本科，其中不乏拥有硕士学位及高级职称的专业技术人员。

      团队成员不仅理论基础扎实，更在 企事业单位定制软件开发、系统平台研发、行业软件开发 等方面积累了丰富的实战经验。无论是复杂业务系统的构建，还是前沿技术的应用落地，团队都能提供稳定、高效的技术支持。
            </p>
             <p>
     &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;天津吾行大数据有限公司，坚持以技术为本、以客户为中心，围绕 服务企业出海、企业管理与业务软件、定制化开发与营销服务 三大板块，持续为各行业客户提供优质的软件产品与定制化解决方案。
               </p>
                <p>
     &nbsp;&nbsp; &nbsp;&nbsp; &nbsp;来，我们将继续深耕数字化服务，助力更多企业实现管理升级与全球拓展。
                    </p>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部 -->
    <Footer v-bind="footerData" />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import api from '@/api';
import { pageDataMixin } from '@/mixins/pageData';

export default {
  name: "About",
  components: {
    Navbar,
    Footer
  },
  mixins: [pageDataMixin],
  data() {
    return {
      aboutInfo: {
        title: '',
        contentAll: ''
      }
    };
  },
  mounted() {
    this.fetchAboutInfo();
  },
  methods: {
    fetchAboutInfo() {
      api.get("/api/ent/getHomePageEntInfo")
        .then(response => {
          if (response.data.code === 0) {
            this.aboutInfo = {
              title: response.data.data.title,
              contentAll: response.data.data.contentAll
            };
          }
        })
        .catch(() => {
          // 静默处理错误
        });
    }
  }
};
</script>

<style scoped>
.about {
  font-family: Arial, sans-serif;
}

/* 通用样式 */
.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
}

.about-content {
  padding: 4rem 0;
}

.about-content h2 {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 3rem;
}

.about-section {
  margin-bottom: 2rem;
}

.about-section h3 {
  margin-bottom: 1rem;
  font-size: 1.3rem;
}

.about-section ul {
  list-style: disc;
  padding-left: 2rem;
}

.about-section li {
  margin-bottom: 0.5rem;
}




/* 响应式设计 */
@media (max-width: 768px) {
  .nav-links {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .footer-content {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
  }
  
  .footer-details {
    flex-direction: column;
    min-width: 100%;
  }
  
  .company-info {
    min-width: 100%;
    text-align: center;
  }
  
  .company-info h3,
  .company-info p {
    text-align: center;
  }
  
  .core-business h4 {
    text-align: center;
  }
  
  .core-business p,
  .contact-info p {
    text-align: center;
  }
}
</style>